import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import type { Json } from "./settings.server";

export const getStoreSettingsFn = createServerFn({ method: "GET" }).handler(async () => {
  const s = await import("./settings.server");
  return s.fetchStoreSettings();
});

export const saveStoreSettingsFn = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((input: { settings: { [key: string]: Json } }) => {
    if (!input?.settings) throw new Error("settings required");
    return input;
  })
  .handler(async ({ data, context }) => {
    const admin = await import("@/lib/admin/console.server");
    await admin.assertElevated(context as never);
    const s = await import("./settings.server");
    return s.saveStoreSettings(data.settings, context.userId);
  });
